import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { setTitle, setMeta, setCanonical, setJsonLd } from "@/lib/seo";

// Fetches Nuwtonic SEO overrides for the current path and applies them to the
// document head / DOM after the page has rendered. Overrides win over defaults.
export default function SeoOverrides() {
  const { pathname } = useLocation();
  useEffect(() => {
    let cancelled = false;
    const apply = async () => {
      let overrides = [];
      try {
        const { data } = await api.get("/seo/overrides", { params: { path: pathname } });
        overrides = data.overrides || [];
      } catch {
        return;
      }
      if (cancelled || overrides.length === 0) return;
      // Allow the page's own effects to run first, then override.
      setTimeout(() => {
        if (cancelled) return;
        overrides.forEach((o) => {
          const v = o.value;
          switch (o.type) {
            case "meta_title":
              setTitle(v);
              setMeta("og:title", v, "property");
              break;
            case "meta_description":
              setMeta("description", v);
              setMeta("og:description", v, "property");
              break;
            case "og_title":
              setMeta("og:title", v, "property");
              break;
            case "og_description":
              setMeta("og:description", v, "property");
              break;
            case "canonical":
              setCanonical(v);
              break;
            case "schema_jsonld":
              setJsonLd(`seo-override-jsonld`, v);
              break;
            case "h1": {
              const h1 = document.querySelector(o.selector || "h1");
              if (h1) h1.textContent = v;
              break;
            }
            case "alt_text": {
              if (o.selector) {
                document.querySelectorAll(o.selector).forEach((img) => img.setAttribute("alt", v));
              }
              break;
            }
            default:
              break;
          }
        });
      }, 120);
    };
    apply();
    return () => { cancelled = true; };
  }, [pathname]);
  return null;
}
